import LabLoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { Box, Tooltip } from '@mui/material';

export default function LoadingButton({
    loading,
    startIcon,
    tooltip = '',
    ...rest
}: LoadingButtonProps & { tooltip?: string }) {
    return (
        <Tooltip title={tooltip}>
            <span>
                <LabLoadingButton
                    loading={loading}
                    loadingPosition="start"
                    // Add some padding to the startIcon loading spinner so it doesn't overlap the text
                    startIcon={
                        loading ? <Box sx={{ paddingLeft: 1, paddingRight: 2 }}></Box> : startIcon
                    }
                    {...rest}
                />
            </span>
        </Tooltip>
    );
}
